// @flow
import React from 'react'
import { ClearFix } from '../controls'
import styled, { type StyledComponent } from 'styled-components'
import OptionalResponsibleImage from './OptionalResponsibleImage'
import type { Media, Crop } from '../../types'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  width: 296px;
  padding: 10px;
  border: 1px solid #cecece;
  background: #fff;
  float: left;
  word-wrap: break-word;
`
const Title: StyledComponent<Object, any, any> = styled.div`
  margin-top: 8px;
  border: 0 none rgb(59, 89, 152);
  color: #3b5998;
  column-rule-color: rgb(59, 89, 152);
  font-family: Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 15.36px;
  outline: rgb(59, 89, 152) none 0;
  overflow: hidden;
  width: 290px;
`
const Text: StyledComponent<Object, any, any> = styled.div`
  border: 0 none rgb(144, 148, 156);
  color: rgb(144, 148, 156);
  column-rule-color: rgb(144, 148, 156);
  font-family: Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 15.36px;
  outline: rgb(144, 148, 156) none 0;
`
const Url: StyledComponent<Object, any, any> = styled.div`
  border: 0 none rgb(59, 89, 152);
  color: #3b5998;
  column-rule-color: rgb(59, 89, 152);
  font-family: Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 15.36px;
  height: 15px;
  outline: rgb(59, 89, 152) none 0;
  overflow: hidden;
  padding: 0;
  perspective-origin: 127px 7.5px;
  text-overflow: ellipsis;
  transform-origin: 127px 7.5px;
  white-space: nowrap;
  width: 254px;
`

type Props = {|
  title: string,
  description: string,
  url: string,
  image: ?Media,
  imageCrop: ?Crop
|}

export default function FacebookPreview(props: Props) {
  const { url, title, description, image, imageCrop } = props

  return (
    <Wrapper>
      <ClearFix>
        <OptionalResponsibleImage image={image} imageCrop={imageCrop} width={274} ratio={1.91} />
      </ClearFix>
      <Title>{title}</Title>
      <Url>{url}</Url>
      <Text>
        <div>{description}</div>
      </Text>
    </Wrapper>
  )
}
